/* ============================================================
   WISENT MOBILE DRAWER
   Markup: snippets/wisent-nav-mobile.liquid
   Styles: assets/wisent-nav-drawer.css
   ============================================================ */

(function () {
  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function initDrawer(drawer) {
    if (drawer.dataset.wdrawerBound === 'true') return;
    drawer.dataset.wdrawerBound = 'true';

    var shell = drawer.querySelector('[data-wdrawer-shell]');
    var toggle = document.querySelector('[data-wdrawer-toggle]');
    var panels = drawer.querySelectorAll('[data-wdrawer-panel]');
    var stack = ['root'];
    var scrollY = 0;
    var lastFocus = null;

    function panelByName(name) {
      return drawer.querySelector('[data-wdrawer-panel="' + name + '"]');
    }

    function showPanel(name) {
      var target = panelByName(name);
      if (!target) return;

      panels.forEach(function (panel) {
        panel.classList.remove('is-active', 'is-behind');
      });

      // everything below the top of the stack parks to the left
      stack.slice(0, -1).forEach(function (parked) {
        var el = panelByName(parked);
        if (el) el.classList.add('is-behind');
      });

      target.classList.add('is-active');
      target.scrollTop = 0;
    }

    function goTo(name) {
      stack.push(name);
      showPanel(name);
    }

    function goBack() {
      if (stack.length < 2) return;
      stack.pop();
      showPanel(stack[stack.length - 1]);
    }

    function lockScroll() {
      scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY);
    }

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      lockScroll();

      var first = shell.querySelector(FOCUSABLE);
      if (first) first.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      unlockScroll();

      // reset to the root panel so the next open starts clean
      stack = ['root'];
      showPanel('root');

      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (drawer.classList.contains('is-open')) {
          close();
        } else {
          open();
        }
      });
    }

    drawer.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-wdrawer-open]');
      if (openBtn) {
        goTo(openBtn.dataset.wdrawerOpen);
        return;
      }

      var backBtn = event.target.closest('[data-wdrawer-back]');
      if (backBtn) {
        goBack();
        return;
      }

      if (event.target.closest('[data-wdrawer-close]')) close();
    });

    document.addEventListener('keydown', function (event) {
      if (!drawer.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        close();
        return;
      }

      if (event.key !== 'Tab') return;

      // keep focus inside the drawer while it is open
      var active = shell.querySelector('.wdrawer__panel.is-active');
      var scope = active || shell;
      var items = Array.prototype.filter.call(
        shell.querySelectorAll(FOCUSABLE),
        function (el) {
          return el.offsetParent !== null && (scope.contains(el) || !el.closest('[data-wdrawer-panel]'));
        }
      );
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-wdrawer]').forEach(initDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // re-init when the theme editor re-renders the header section
  document.addEventListener('shopify:section:load', boot);
})();
